export default "__VITE_ASSET__06bb0f18__"